import { get, post, del, axiosPut } from "helpers/api_helper"
import { call, put, takeEvery } from "redux-saga/effects"
import * as url from "helpers/url_helper"
import { showToast } from "utils"
import {
  createMetaTagFailed,
  createMetaTagSuccess,
  deleteMetaTagFailed,
  deleteMetaTagSuccess,
  getMetaTagsFailed,
  getMetaTagsSuccess,
  getTagFailed,
  getTagSuccess,
  hideDeleteTagModal,
  mergeMetaTagsFailed,
  mergeMetaTagsSuccess,
  updateMetaTagFailed,
  updateMetaTagSuccess,
} from "./actions"
import {
  CREATE_META_TAG,
  DELETE_META_TAG,
  GET_META_TAGS,
  GET_TAG,
  MERGE_META_TAGS,
  UPDATE_META_TAG,
} from "./actionTypes"

function* getMetaTags({ payload: params }) {
  try {
    const response = yield get(url.ADMIN_META_TAGS, { params })
    yield put(getMetaTagsSuccess(response))
  } catch (error) {
    yield put(getMetaTagsFailed(error))
    showToast("error", error, "Error")
  }
}

function* createMetaTag({ payload: params }) {
  try {
    const response = yield post(url.ADMIN_META_TAGS, params?.values)
    yield put(createMetaTagSuccess(response))
    showToast("success", "Meta tag created!", "Success")
    if (params?.callback) {
      params?.callback()
    }
  } catch ({ response }) {
    yield put(createMetaTagFailed(response?.data?.error))
    showToast("error", response?.data?.error, "Error")
  }
}

function* deleteMetaTag({ payload: params }) {
  try {
    const response = yield del(url.ADMIN_META_TAGS + "/" + params?.id)
    yield put(deleteMetaTagSuccess(response))
    if (params?.callback) {
      params.callback()
    }
    showToast("success", "Meta tag deleted!", "Success")
  } catch (error) {
    yield put(deleteMetaTagFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateMetaTag({ payload: params }) {
  try {
    const response = yield axiosPut(
      url.ADMIN_META_TAGS + "/" + params?.id,
      params.values
    )
    yield put(updateMetaTagSuccess(response))
    if (params?.callback) {
      params.callback()
    }
    showToast("success", "Meta tag updated!", "Success")
  } catch (error) {
    yield put(updateMetaTagFailed(error))
    showToast("error", error, "Error")
  }
}

function* mergeMetaTags({ payload: params }) {
  try {
    const response = yield post(url.ADMIN_META_TAGS + "/merge", params.values)
    yield put(mergeMetaTagsSuccess(response))
    if (params?.callback) {
      params.callback()
    }
    showToast("success", "Tags merged!", "Success")
  } catch (error) {
    yield put(mergeMetaTagsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getTag({ payload: params }) {
  try {
    const response = yield get(url.ADMIN_META_TAGS + `/${params?.id}`)
    yield put(getTagSuccess(response))
  } catch ({ response }) {
    yield put(getTagFailed(response?.data?.error))
    showToast("error", response?.data?.error, "Error")
  }
}

function* tagsSaga() {
  yield takeEvery(GET_META_TAGS, getMetaTags)
  yield takeEvery(CREATE_META_TAG, createMetaTag)
  yield takeEvery(DELETE_META_TAG, deleteMetaTag)
  yield takeEvery(UPDATE_META_TAG, updateMetaTag)
  yield takeEvery(MERGE_META_TAGS, mergeMetaTags)
  yield takeEvery(GET_TAG, getTag)
}

export default tagsSaga
